<script setup>
import PlanningKeywordForm from '@frontJs/components/forms/projectManagement/sea/PlanningKeywordForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    tenant,
    googleAdsPlanningKeyword,
    googleAdsPlanningKeywordCountries,
    googleAdsPlanningKeywordLanguages,
    googleAdsPlanningKeywordPlanNetworks,
} = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    googleAdsPlanningKeyword: {
        type: Object,
        required: false,
    },
    googleAdsPlanningKeywordCountries: {
        type: Object,
        required: true,
    },
    googleAdsPlanningKeywordLanguages: {
        type: Array,
        required: true,
    },
    googleAdsPlanningKeywordPlanNetworks: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="googleAdsPlanningKeyword">
            Mettre à jour le mot-clé #{{ googleAdsPlanningKeyword.id }} -
            Mots-clés - Planification - SEA - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un mot-clé - Mots-clés - Planification - SEA - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="googleAdsPlanningKeyword" :tenant-name="tenant.name">
        Gestion de projet - SEA - Planification - Mots-clés - Mettre à jour le
        mot-clé #{{ googleAdsPlanningKeyword.id }}
    </PageTitle>

    <PageTitle v-else :tenant-name="tenant.name">
        Gestion de projet - SEA - Planification - Mots-clés - Créer un mot-clé
    </PageTitle>

    <PlanningKeywordForm
        :tenant="tenant"
        :google-ads-planning-keyword="googleAdsPlanningKeyword"
        :google-ads-planning-keyword-countries="
            googleAdsPlanningKeywordCountries
        "
        :google-ads-planning-keyword-languages="
            googleAdsPlanningKeywordLanguages
        "
        :google-ads-planning-keyword-plan-networks="
            googleAdsPlanningKeywordPlanNetworks
        "
    />
</template>
